import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onFilterOption", "placeholder"];
import React, { useCallback, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import Select from '@atlaskit/select';
import { MetaActions } from '../../../common/types';
import Control from './control';
import DropdownIndicator from './dropdown-indicator';
import Menu from './menu';
import messages from './messages';
import Option from './option';
export var selectComponents = {
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  LoadingIndicator: null,
  Menu: Menu,
  Option: Option
};
var onIsOptionDisabled = function onIsOptionDisabled(option) {
  return 'error' in option ? !!option.error : false;
};
export var LocalBaseSelect = function LocalBaseSelect(_ref) {
  var onFilterOption = _ref.onFilterOption,
    placeholder = _ref.placeholder,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var intl = useIntl();
  var ariaLabelProp = restProps.ariaLabel,
    onInputChangeProp = restProps.onInputChange,
    inputValueProp = restProps.inputValue;
  var _useState = useState(inputValueProp || ''),
    _useState2 = _slicedToArray(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  var onInputChange = useCallback(function (newValue, actionMeta) {
    /**
     * Do not clear the filter input value when an input is selected or blurred.
     * NOTE: We are also returning when 'menu-close' event are triggered,
     * which happens when the input is clicked for some reason, but not when we click outside of the dropdown
     * */
    if ([MetaActions.setValue, MetaActions.inputBlur, MetaActions.menuClose].includes(actionMeta.action) && !newValue.length) {
      return;
    }
    onInputChangeProp === null || onInputChangeProp === void 0 || onInputChangeProp(newValue, actionMeta);
    setInputValue(newValue);
  }, [onInputChangeProp]);
  return /*#__PURE__*/React.createElement(Select, _extends({}, restProps, {
    label: ariaLabelProp || intl.formatMessage(messages.searchPlaceholder),
    autoFocus: true,
    backspaceRemovesValue: false,
    blurInputOnSelect: false,
    closeMenuOnSelect: false,
    controlShouldRenderValue: false,
    hideSelectedOptions: false,
    isClearable: false,
    isMulti: true,
    inputValue: inputValue,
    menuIsOpen: true,
    menuShouldScrollIntoView: false,
    tabSelectsValue: false,
    noOptionsMessage: function noOptionsMessage() {
      return intl.formatMessage(messages.noOptionsMessage);
    },
    onInputChange: onInputChange,
    isOptionDisabled: onIsOptionDisabled,
    filterOption: onFilterOption,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : /*#__PURE__*/React.createElement(FormattedMessage, messages.searchPlaceholder)
  }));
};